// extracted by mini-css-extract-plugin
module.exports = {"head":"taxEditor_head__3nG7u","title":"taxEditor_title__s6YkC"};